import HttpService from "./httpService";

export const getWelcomeMessage = () => {
  let uri = `/home/test`;

  return async () => {
    return HttpService.getRequest(uri);
  };
};
